module.exports = __webpack_public_path__ + "img/58200.64b28162.jpg";